var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'backbone', 'core', 'mixin', 'app-common/component/loader', 'app-common/component/popover', 'app-common/component/combobox', 'app-common/component/notification', 'model/ledger-account', 'template/ledger-accounts/add-ledger-form.htm', 'common/lib/forms/jquery.checkbox'], function($, _, Backbone, core, mixin, loader, Popover, Combobox, NotificationSupport, LedgerAccountModel, addledgerTemplate) {
  var CreateLedgerForm;
  return CreateLedgerForm = (function(_super) {

    __extends(CreateLedgerForm, _super);

    function CreateLedgerForm() {
      CreateLedgerForm.__super__.constructor.apply(this, arguments);
    }

    CreateLedgerForm.prototype.className = 'manage-ledger-form';

    CreateLedgerForm.prototype.events = {
      'change .ledger-role': 'changeType',
      'change input[name=ledger-category]': 'changeRole'
    };

    CreateLedgerForm.prototype.initialize = function() {
      this.collection = core.getCollection('ledgerAccounts');
      return this.categoryCollection = core.getCollection('ledgerAccountCategories');
    };

    CreateLedgerForm.prototype.render = function(wrapperTemplate) {
      var currenciesCombobox, template;
      currenciesCombobox = new Combobox('ledger-currency', 'ledger-currency', null, core.getCollection('currencies').toJSON(), core.getCurrentClientCurrencyId(), {
        name: 'code',
        value: 'id'
      });
      template = wrapperTemplate ? _.template(wrapperTemplate, {
        form: addledgerTemplate
      }) : addledgerTemplate;
      this.$el.html(_.template(template, {
        currenciesCombobox: currenciesCombobox.show(),
        categories: this.categoryCollection.filteredByFlags()
      }));
      this.$el.find('input[type=radio]').checkbox({
        mode: 'radio'
      });
      this.$el.find('#ledger-form-type').hide();
      return this.$el.find('#ledger-form-role').hide();
    };

    CreateLedgerForm.prototype.changeType = function(e) {
      var ledgerType;
      if ($(e.currentTarget).val() !== '') {
        ledgerType = 'Process';
      } else {
        ledgerType = 'Flavor';
      }
      this.$el.find("#ledger-type").text(ledgerType);
      return this.showDayOfMonth(ledgerType);
    };

    CreateLedgerForm.prototype.showDayOfMonth = function(ledgerType) {
      return this.$el.find(".ledger-day").toggle(ledgerType === 'Process');
    };

    CreateLedgerForm.prototype.renderError = function(errors) {
      return this.showNotification({
        containerSelector: '.notification-ledger-form',
        type: 'error',
        text: errors
      }, true, false);
    };

    CreateLedgerForm.prototype.changeRole = function(e) {
      if ($(e.currentTarget).prop('checked')) {
        switch ($(e.currentTarget).val()) {
          case '1':
            this.$el.find('.ledger-role').hide();
            return this.$el.find('#ledger-role-bank').show();
          case '3':
            this.$el.find('.ledger-role').hide();
            return this.$el.find('#ledger-role-cc').show();
          case '5':
            this.$el.find('.ledger-role').hide();
            return this.$el.find('#ledger-role-equity').show();
          default:
            this.$el.find('.ledger-role').hide();
            this.$el.find("#ledger-type").text('Flavor');
            this.$el.find('.ledger-role').val('');
            this.$el.find('.ledger-day').val('');
            return this.showDayOfMonth('Flavor');
        }
      }
    };

    CreateLedgerForm.prototype.addLedger = function(callback) {
      var ledgerAccount,
        _this = this;
      ledgerAccount = new LedgerAccountModel({
        name: this.$el.find('#ledger-name').val(),
        categoryId: this.$el.find('input[name=ledger-category]:checked').val()
      });
      if (this.$el.find('#ledger-currency:visible').length) {
        ledgerAccount.set('currencyId', this.$el.find('#ledger-currency').val());
      }
      if (this.$el.find('.ledger-role:visible').length) {
        ledgerAccount.set('role', this.$el.find('.ledger-role:visible').val() || null);
      }
      if (this.$el.find('.ledger-day:visible').length) {
        ledgerAccount.set('statementDayOfMonth', parseInt(this.$el.find('.ledger-day:visible').val() || null));
      }
      loader.init();
      ledgerAccount.on('invalid', function(model, validationError) {
        loader.hide();
        return _this.renderError(validationError);
      });
      return this.collection.create(ledgerAccount, {
        wait: true,
        success: function() {
          loader.hide();
          return typeof callback === "function" ? callback() : void 0;
        },
        error: function(model, response) {
          var errors;
          errors = JSON.parse(response.responseText);
          loader.hide();
          return _this.renderError(_.values(errors.messages).join(", "));
        }
      });
    };

    return CreateLedgerForm;

  })(mixin.of(Backbone.View, NotificationSupport));
});
